"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultErrors = void 0;
var en_1 = __importDefault(require("./en"));
exports.ResultErrors = { en: en_1.default };
//# sourceMappingURL=errors.js.map